/**
 * AES加密解密工具类工具类
 */
import Vue from 'vue'
import CryptoJS from 'crypto-js'

// 此处key为16进制
const keyStr = '385f33cb91484b04a177828829081ab7'

/**
 * 字符串加密
 * @Description
 * @params
 * @author LiXiaoHui
 * @date: 2022/3/23
 */
export function encrypt(word) {
  // key格式化处理
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const encrypted = CryptoJS.AES.encrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.ciphertext.toString()

}

/**
 * 字符串解密
 * @Description
 * @params
 * @author LiXiaoHui
 * @date: 2022/3/23
 */
export function decrypt(word) {
  const key = CryptoJS.enc.Hex.parse(keyStr)
  var decrypt = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(word), key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}




// WEBPACK FOOTER //
// ./src/utils/encryption.js